import { lazy, useState } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";
import { Link, useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import { useIsMobile } from "@/common/hooks/useIsMobile";
import BurgerIcon from "@/common/svg/burger-icon.svg";
import Logo from "@/common/svg/logo-neo-credit.svg";
import { LangSwitcher } from "@/features/LangSwitcher";
import { useLocationMatch } from "@/router/hooks/useLocationMatch";
import { IconButton } from "@/shared/ui/Buttons/IconButton";
import { MainButton } from "@/shared/ui/Buttons/MainButton";
import { SecondaryButton } from "@/shared/ui/Buttons/SecondaryButton";
import { CallCenter } from "@/shared/ui/CallCenter";
import Drawer from "@/widgets/Drawer";

const MediationLink = lazy(
  () => import("@/entities/mediation/ui/MediationHeaderLink"),
);

export const Header = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const token = localStorage.getItem("token");
  const {
    authLocationMatch,
    paymentsInfoLocationMatch,
    paymentLocationMatch,
    mediationLocationMatch,
  } = useLocationMatch();

  const showCabinetLink = !isMobile;
  const showAuthLink = !authLocationMatch && !token && isMobile;

  const [toggleDrawer, setToggleDrawer] = useState(false);

  const handleToggleDrawer = () => {
    setToggleDrawer((prev) => !prev);
  };

  const navigatePaymentsInfo = () => {
    navigate("/payments-info");
  };

  const navigatePayment = () => {
    navigate("/payment");
  };

  const navigateCabinet = () => {
    navigate("/auth");
  };

  return (
    <>
      <header className={styles.headerWrapper}>
        <div className={cn("container", styles.headerContainer)}>
          <div className={styles.left}>
            <Link id="logo-link-button" to="/">
              <Logo />
            </Link>
            {!isMobile && <CallCenter />}
            {!isMobile && <LangSwitcher />}
          </div>
          <div className={styles.right}>
            <nav className="desktop-display flex items-center gap-4">
              <SecondaryButton
                id="header-payments-info"
                text={<FormattedMessage defaultMessage="Способы оплаты" />}
                onClick={navigatePaymentsInfo}
                active={paymentsInfoLocationMatch}
              />
              <SecondaryButton
                id="header-make-payment"
                onClick={navigatePayment}
                text={<FormattedMessage defaultMessage="Внести оплату" />}
                active={paymentLocationMatch}
              />
              {/*{!!token && (*/}
              {/*  <Suspense fallback={null}>*/}
              {/*    <MediationLink*/}
              {/*      navigate={navigate}*/}
              {/*      active={mediationLocationMatch}*/}
              {/*    />*/}
              {/*  </Suspense>*/}
              {/*)}*/}
            </nav>
            {showAuthLink && (
              <MainButton
                id="header-sigin"
                className={styles.mainButton}
                text={<FormattedMessage defaultMessage="Войти" />}
                onClick={navigateCabinet}
              />
            )}
            {showCabinetLink && (
              <MainButton
                id="header-sigin"
                className={styles.mainButton}
                text={<FormattedMessage defaultMessage="Личный кабинет" />}
                onClick={navigateCabinet}
              />
            )}
            {isMobile && (
              <IconButton
                id="toggle-drawer"
                Icon={BurgerIcon}
                onClick={handleToggleDrawer}
                className="mobile-display"
              />
            )}
          </div>
        </div>
      </header>
      {toggleDrawer && (
        <Drawer toggle={toggleDrawer} toggleHandler={handleToggleDrawer} />
      )}
    </>
  );
};
